import React, { useState } from "react";
import Image from "react-bootstrap/Image";
import {Button, Col, Container, Row} from "react-bootstrap";
import TeamPlayers from "./TeamDetails/TeamPlayers";
import TeamResults from "./TeamDetails/TeamResults";
import {useFetchTeam} from "../../features/team/teamApi";

type Props = {
    slug: string;
};

const SingleTeam = ({slug}: Props) => {
    const [showDetails, setShowDetails] = useState(true);

    const {data:team} = useFetchTeam(slug);

    if (!team || !team.users) {
        return <></>;
    }

    return (
        <Container className={"mt-5"}>
            <Row>
                <Image fluid src={team.carousel_img} className={"w-100"} />
                <Container className={"mt-4"}>
                    <Row>
                        <Col md={4} className={'d-flex position-relative mt-3 mb-3'}>
                            <Image
                                roundedCircle={true}
                                src={team.team_image}
                                style={{ width: "150px", height: "150px" }}
                            />
                            <div className={'ms-4'}>
                                <h2 className={'font-weight-bold'}>{team.name}</h2>
                                <p >{team.description}</p>
                            </div>
                        </Col>
                        <Col md={2}>
                            <div className="d-flex align-items-center justify-content-center text-center flex-column w-100 ">
                            <h4>CREATED</h4>
                                <h2>2017-08-12</h2>
                            </div>
                        </Col>
                        <Col md={2}>
                            <div className="d-flex align-items-center justify-content-center text-center flex-column w-100 ">
                                <h4>Ilość Osób</h4>
                                <h2> 8 </h2>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="d-flex align-items-center flex-column  ">
                            <h4>Options</h4>
                                <Button variant="success" className={` mb-1 w-25 ${showDetails ? 'active' : ''} `} onClick={() => setShowDetails(true)}>Players</Button>
                                <Button variant="success" className={` mb-1 w-25 ${showDetails ? '' : 'active'}`} onClick={() => setShowDetails(false)}>Results</Button>
                                <Button variant="info" className={'w-25'}>Edit</Button>
                            </div>
                        </Col>
                    </Row>
                    {showDetails ?
                        <Row>
                            <h1 className={`text-center`}>Players</h1>
                            {team.users.map((user) => (
                                <Col xs={12} md={6} lg={4} key={user.id}>
                                    <TeamPlayers key={user.id} user={user} />
                                </Col>
                            ))}
                        </Row>
                        :
                        <Row>
                            <h1 className={`text-center`}>Results</h1>
                            <TeamResults team={team} />
                        </Row>
                    }
                </Container>
            </Row>
        </Container>
    );
};

export default SingleTeam;
